// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"91f1f8da","818":"91f1f8da"}[chunkId] + ".chunk.css";
};